// Loga info do deploy no console ao ser importado (side-effect) — apenas em dev/homolog.
// Producao nao tem .env -> VUE_APP_AMBIENTE indefinido -> nao loga nada.
// Local (VUE_APP_AMBIENTE = local) tambem nao loga.
// branch e ultimoDeploy vem dos exports VUE_APP_BRANCH/VUE_APP_DEPLOY_TIME no deploy.sh.
if (process.env.VUE_APP_AMBIENTE && process.env.VUE_APP_AMBIENTE !== 'local') {
    console.log('f-contabilidade', {
        branch: process.env.VUE_APP_BRANCH || '-',
        ultimoDeploy: process.env.VUE_APP_DEPLOY_TIME || '-',
    })

    // Overlay visual no canto inferior esquerdo com o branch do deploy.
    // require('../assets/css/environment.css')
    // document.documentElement.style.setProperty(
    //     '--ambiente-label',
    //     `"${process.env.VUE_APP_BRANCH || '-'}"`
    // )
}

// Helper de console: window.getEnvironment() retorna o branch do deploy atual.
window.getEnvironment = () => process.env.VUE_APP_BRANCH || '-'
